import React, { useEffect } from 'react';
import {PageContainer, GuideAppContainer, RenderOnlyFor, PageNavigation, usePages, GuideProgress, useUser, useNeuroState} from '@ignitesales/neuro-application';
import ProductPageProvider from '@ignitesales/neuro-application/src/neuro-guide/guide-framework/components/ProductPageContext';

import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import DetailsPage from './components/pages/DetailsPage';
import Header from './components/Header';
import HeaderSummary from './components/HeaderSummary';
import Footer from './components/Footer';
import { BreakpointProvider } from '@ignitesales/neuro-application/src/neuro-ui';
import { CircularProgressbar } from 'react-circular-progressbar';

const queries = {
  xs: '(min-width: 0px)',
  sm: '(min-width: 600px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1279px)',
  xxl: '(min-width: 1449px)',
  horizontal: '(orientation: landscape)'
};

const App = () => {
  const { isLoadingNextPage, progress: { currentPage } } = usePages();
  const { assignment } = useUser();
  const { employeeLoginState = {} } = useNeuroState();
  const employeeHasLoggedIn = employeeLoginState?.loginComplete;


  useEffect(() => {
    if (employeeHasLoggedIn && assignment?.branch?.clientId) {
      const saveClientId = async () => {
        const isCrossSellPilotLaunchBranch = await ignite.answerService.getAnswer('isCrossSellPilotLaunchBranch');
        const logginBranch = await ignite.answerService.getAnswer('logginBranch');
        await ignite.answerService.saveAnswer({
          appkey: 'logginBranch',
          value: [assignment.branch.clientId],
          timestamp: new Date(),
        });

      };
      saveClientId();
    }
  }, [assignment?.branch, employeeHasLoggedIn]);

  useEffect(() => {
    if(!isLoadingNextPage) {
      window.scrollTo(0, 0)
    }
  }, [isLoadingNextPage])

  useEffect(() => {
    window.ATL_JQ_PAGE_PROPS = {
      fieldValues: {
        component : 'Commerce Bank Guide'
      }
    };
    const script = document.createElement('script');
  
    script.src = "https://ignitesales.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/l24at6/b/0/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=920e80a9";
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  const backToGuideSelector = currentPage === 1 ? () => window.location.href = "/static/guide-selector.html" : undefined;

  return (
    <BreakpointProvider queries={queries}>
      <GuideAppContainer>
        <RenderOnlyFor forLandingPage forSurveyPage forDetailsPage>
          <Header/>
        </RenderOnlyFor>
        <RenderOnlyFor forSummaryPage>
          <ProductPageProvider Component={HeaderSummary} />
        </RenderOnlyFor>
        <PageContainer
          LandingPage={LandingPage}
          SurveyPage={SurveyPage}
          SummaryPage={SummaryPage}
          DetailsPage={DetailsPage}
        />
        <RenderOnlyFor forSurveyPage>
          <PageNavigation
            toastTimeout={ 2000 }
            onPreviousPageClicked={backToGuideSelector}
          />
          <GuideProgress render={ props => <CircularProgressbar value={props.progress} text={`${props.progress}%`} /> } />
        </RenderOnlyFor>
        <Footer />
      </GuideAppContainer>
    </BreakpointProvider>
  );
};

export default App;
